import { useMemo } from "react";

import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

import PrintableMemoFieldTitle from "pages/Deal/PrintableMemo/components/PrintableMemoFieldTitle";

import { IPackageDetailsField } from "entities/Checklist/sdk";

export interface IPrintableMemoSignaturefield {
  field: IPackageDetailsField;
  isNASection: boolean;
}

const PrintableMemoSignaturefield = ({
  field,
  isNASection,
}: IPrintableMemoSignaturefield) => {
  const isNAField = useMemo(
    () => field.n_a_status || isNASection,
    [field, isNASection]
  );

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="flex-start"
        sx={{
          paddingBottom: theme.spacing(1),
          borderBottom: `1px solid ${colors.blue40}`,
        }}
      >
        <PrintableMemoFieldTitle field={field} disabled={isNAField} />
        {isNAField ? (
          <Text sx={{ opacity: 0.5 }} data-testid="field-value-na">
            N/A
          </Text>
        ) : (
          <Box
            sx={{
              height: "60px",
              flex: 1,
              border: "1px solid #c5c5ee",
              position: "relative",
              breakInside: "avoid",
              pageBreakInside: "avoid",
            }}
          >
            <Text
              variant="labelSmall"
              sx={{
                position: "absolute",
                right: theme.spacing(0.5),
                bottom: theme.spacing(0.5),
              }}
            >
              Signature
            </Text>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default PrintableMemoSignaturefield;
